"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectMobileDevice = detectMobileDevice;
exports.getMobileOperatingSystem = getMobileOperatingSystem;
exports.detectIOS = detectIOS;
exports.detectAndroid = detectAndroid;
exports.detectTouchScreen = detectTouchScreen;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

function detectMobileDevice() {
  if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 // to detect iPad iOS 13 or later
  ) {
    return true;
  }

  return false;
}

function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera; // Windows Phone must come first because its UA also contains "Android"

  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
}

function detectIOS() {
  return getMobileOperatingSystem() === 'iOS';
}

function detectAndroid() {
  return getMobileOperatingSystem() === 'Android';
} // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent


function detectTouchScreen() {
  var hasTouchScreen = false;

  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator.maxTouchPoints > 0;
  } else if ('msMaxTouchPoints' in navigator) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    hasTouchScreen = navigator.msMaxTouchPoints > 0;
  } else {
    var mQ = window.matchMedia && matchMedia('(pointer:coarse)');

    if (mQ && mQ.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      hasTouchScreen = detectMobileDevice();
    }
  }

  return hasTouchScreen;
}